import { Button } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import warning from "./../../assets/images/warning.svg";

const AlreadyReferred = () => {
  const navigate = useNavigate();
  const { state } = useLocation();

  const backBtnHandler = () => {
    navigate("/remote-care");
  };
  const changePatientHandler = () => {
    navigate("/patient-phone-number", { state: state });
  };

  return (
    <div>
      <div className="w-full absolute top-[12%] left-0">
        <div className="mx-auto max-w-[1280px] w-full px-12 flex flex-col gap-y-2 items-center">
          <img src={warning} alt="warning" />
          <div className="text-2xl font-semibold pt-6">
            Patient already referred!
          </div>
          <div>
            This patient is already referred by another doctor in our ecosystem.
            So this Referral won’t be eligible for incentives. For further
            clarification, please contact our customer support team.
          </div>
        </div>
      </div>
      <div className="w-full fixed bottom-4 left-0">
        <div className="mx-auto max-w-[1280px] w-full p-4 flex flex-col gap-y-4">
          <Button
            type="primary"
            className="w-full h-14 rounded-2xl bg-[#4B4AD5] p-5 text-lg font-medium"
            onClick={changePatientHandler}
          >
            Change Patient Details
          </Button>
          <Button
            type="primary"
            className="w-full h-14 rounded-2xl border-[#4B4AD5] text-[#4B4AD5] bg-[transparent] p-5 text-lg font-medium"
            onClick={backBtnHandler}
          >
            Back To Home
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AlreadyReferred;
